import styled from "styled-components";

export const AddIssueModal = styled.div`
  transition: all 0.1s ease-in-out;
  width: 400px;
  position: fixed;
  bottom: 50px;
  right: 50px;
  background: #20555b;
  border-radius: 10px;
  opacity: ${({show}) => show ? '1' :  '0'};
  visibility: ${({show}) => show ? 'visible' :  'hidden'};
  transform: translateY(${({show}) => show ? '0px' :  '40px'});
  
`;
